import Scrim from "./Scrim";
export default Scrim;
export { Scrim };
